export default class FaqAccordion {
    constructor(className) {
        this.accordionHeader = Array.from(
            document.querySelectorAll(`.${className}`)
        );

        if (this.accordionHeader.length) {
            this.events();
        }
    }

    events() {
        this.accordionHeader.forEach((item) =>
            item.addEventListener("click", this.toggleAccordion.bind(this))
        );
    }

    toggleAccordion(e) {
        const currentItem = e.currentTarget;
        for (let i = 0; i < this.accordionHeader.length; i++) {
            if (
                this.accordionHeader[i].classList.contains("open") &&
                this.accordionHeader[i] !== currentItem
            ) {
                this.accordionHeader[i].classList.remove("open");
            }
        }

        if (currentItem.classList.contains("open")) {
            currentItem.classList.remove("open");
        } else {
            currentItem.classList.add("open");
        }
    }
}
